<div>
    <button title="Exportar a Excel" (click)="export()" class="btn btn-outline-success mx-0"><i
        class="fa fa-file-excel-o"></i></button>
    <button title="Exportar a CSV" (click)="exportToCSV()" class="btn btn-outline-success mx-2"><i
        class="bi bi-filetype-csv"></i></button>
    <button title="Exportar a PDF" (click)="exportPDF()" class="btn btn-outline-danger"><i
        class="fa fa-file-pdf-o"></i></button>
  </div>
